import { render, staticRenderFns } from "./GestioneAziendaExtra.vue?vue&type=template&id=ff5c4338&"
import script from "./GestioneAziendaExtra.vue?vue&type=script&lang=js&"
export * from "./GestioneAziendaExtra.vue?vue&type=script&lang=js&"
import style0 from "./GestioneAziendaExtra.vue?vue&type=style&index=0&id=ff5c4338&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports